<template>
  <div class="risk-info-container">
    <div class="wrap-box-left">
      <IndexTabs
        ref="fx"
        :hot-word="hotWord"
        :country="null"
        :form-items="['countries', 'categories', 'source']"
        url="/front/article/risk/list"
        module="fx"
        type="risk"
        @search="queryGHotword"
      ></IndexTabs>
    </div>

    <div class="wrap-box-right">
      <div class="pbr-title">
        {{
          $t("label.information.informationHotWords")
        }}
      </div>
      <div style="height: 400px;">
        <hot-word-analysis
          v-if="hotWordData.length"
          :word-data="hotWordData"
          @hotClick="hotClick"
        ></hot-word-analysis>
        <Empty v-else></Empty>
      </div>
      <div class="pbr-title">
        {{
           $t("label.information.informationHotspot")
        }}
      </div>
      <normal-list
        :page-size="6"
        :data="hotSpotData"
        :goto="'pbrInfoDetail'"
      ></normal-list>
    </div>
  </div>
</template>
<script>
import IndexTabs from '../info/IndexTabs'
import HotWordAnalysis from '../analysis/HotWordAnalysis'
import NormalList from '../index/NormalList.vue'
export default {
  name: "RiskInfo",
  components: {
    IndexTabs,
    HotWordAnalysis,
    NormalList
  },
  data() {
    return {
      hotWord: '',
      hotWordData: [],
      hotSpotData: []
    };
  },
  methods: {
    queryGHotword (par) {
      let param = par ? {type:'fx',...par} : {type:'fx'}
      this.$pbrApis.queryGHotword(param).then(res => {
        this.hotWordData = res.result
      })
    },
    queryHotSpot () {
      this.$pbrApis.queryHotSpot({type:'fx'}).then(res => {
        this.hotSpotData = res.result
      })
    },
    hotClick (hotWord) {
      this.hotWord = hotWord
    }
  },
  mounted() {
    this.queryGHotword();
    this.queryHotSpot();
  }
};
</script>
<style scoped>
.risk-info-container {
  display: flex;
}
</style>
